<template>
    <Section width="sm">
        <h2 class="section-header">{{ $prismic.asText(data.primary.h2) }}</h2>

        <ul class="list">
            <li
                v-for="(author, index) in $store.state.authors"
                :key="index"
            >
                <Author :id="author.id" :show-tooltips="false" />
            </li>
        </ul>
    </Section>
</template>

<script>
import Author from '@/components/slices/lists/list-items/ListItemAuthor.vue';
export default {
    components: { Author },
    props: {
        data: {
            type: Object,
            required: true,
            default: () => {}
        }
    }
};
</script>

<style lang="scss" scoped>
    .list {
        @include grid(1, 40px);
    }
</style>
